<template>
  <div class="forms">
    <SessionStatus v-if="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_" @resetEnquiry="resetEnquiry" />
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />    
    <TheFeeWaiverForm v-else @submitEnquiry="submitEnquiry" />
  </div>
</template>

<script>
import TheFeeWaiverForm from '@/components/feewaiver/TheFeeWaiverForm.vue'
import Submitted from '@/components/feewaiver/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'

export default {
  name: 'TheFeeWaiver',
  components: {
    TheFeeWaiverForm,
    Submitted,
    SessionStatus
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

